export default "__VITE_ASSET__YBHK3Fy0__"